import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';

import { NEW_CHECKLIST_SELECT_OPTION_CODE } from '../constants/newChecklistSelectOption';
import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';

export const convertChecklistsFormValueToKnmData = (
  values: IKnmErknmForm,
  isDraft: boolean | undefined,
): IKnm248['checklists'] => {
  const { checklistsErknm } = values;

  if (!checklistsErknm) {
    return null;
  }
  const checklistsFiltered = isDraft
    ? checklistsErknm
    : checklistsErknm.filter(item => item.checkList && item.checkList.code !== NEW_CHECKLIST_SELECT_OPTION_CODE);

  return checklistsFiltered.map(item => ({
    isNew: isDraft ? item.isNew : null,
    guid: item.guid || null,
    checkList: item.checkList?.value || null,
    answers:
      item.questions?.map(question => ({
        codeQuestion: question.code,
        answerType: question.answer?.answerType
          ? deleteObjectProperties(question.answer?.answerType, ['label', 'value'])
          : null,
        noteAnswer: question.answer?.noteAnswer || null,
        guid: question.answer?.guid || null,
        dateCreate: question.answer?.dateCreate || null,
      })) || null,
    questionCount: typeof item.questionCount === 'number' ? item.questionCount : null,
    dateCreate: item.dateCreate || null,
    uploadedViaSmev: item.uploadedViaSmev || null,
    ervkCheckList: item.ervkCheckList || null,
  }));
};
